module.exports = __webpack_public_path__ + "static/media/stick1.e831d9c1.png";